module.exports = __webpack_public_path__ + "img/frame (172).00631bba.jpg";